import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/hxBiz',
  component: layout,
  meta: {
    funcID: 'E0010',
    PID: 'E00',
  },
  children: ((pre) => [
    {
      path: 'jdShipment',
      name: `${pre}jdShipment`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E001001',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/hxBiz/jdShipment'),
    },
    {
      path: 'jdShipment/:pageType/:hxShipmentJdCode?',
      name: `${pre}jdShipment-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { hxShipmentJdNo = '' } = $route.query || {}
          return `京造出货计划 | ${hxShipmentJdNo}`
        },
        funcID: 'E001001',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/hxBiz/jdShipment/detail'),
    },
    {
      path: 'jdOrder',
      name: `${pre}jdOrder`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E001002',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/hxBiz/jdOrder'),
    },
    {
      path: 'jdOrder/:pageType/:hxJdOrderCode?/:hxShipmentJdCode?',
      name: `${pre}jdOrder-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { hxJdOrderNo = '' } = $route.query || {}
          return `京造订单查询 | ${hxJdOrderNo}`
        },
        funcID: 'E001002',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/hxBiz/jdOrder/detail'),
    },
    {
      path: 'queryHxFtyPurchaseGoods',
      name: `${pre}queryHxFtyPurchaseGoods`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E001004',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/hxBiz/queryHxFtyPurchaseGoods'),
    },
    {
      path: 'hxFtyPurchaseOrder',
      name: `${pre}hxFtyPurchaseOrder`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E001003',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/hxBiz/hxFtyPurchaseOrder'),
    },
    {
      path: 'hxFtyPurchaseOrder/:pageType/:hxPurchaseCode?',
      name: `${pre}hxFtyPurchaseOrder-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { hxPurchaseNo = '' } = $route.query || {}
          return `合祥工厂采购订单 | ${hxPurchaseNo || 'New'}`
        },
        funcID: 'E001003',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'p-0 bg-transparent' },
        },
      },
      component: () => import('@/views/ecom/hxBiz/hxFtyPurchaseOrder/detail'),
    },
    {
      path: 'preOrder',
      name: `${pre}preOrder`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E001005',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/hxBiz/preOrder'),
    },
    {
      path: 'preOrder/:pageType/:hxPreOrderCode?',
      name: `${pre}preOrder-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { hxPreOrderNo = '' } = $route.query || {}
          return `京东备货订单 | ${hxPreOrderNo || 'New'}`
        },
        funcID: 'E001005',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'p-0 bg-transparent' },
        },
      },
      component: () => import('@/views/ecom/hxBiz/preOrder/detail'),
    },
    {
      path: 'preOrderPurchase',
      name: `${pre}preOrderPurchase`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E001006',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/hxBiz/preOrderPurchase'),
    },
    {
      path: 'hxFtyInvInNotice',
      name: `${pre}hxFtyInvInNotice`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E001007',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/hxBiz/hxFtyInvInNotice'),
    },
    {
      path: 'hxFtyInvInNotice/:pageType/:hxFtyNoticeInCode?',
      name: `${pre}hxFtyInvInNotice-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { hxFtyNoticeInNo = '' } = $route.query || {}
          return `外厂入库通知单 | ${hxFtyNoticeInNo || 'New'}`
        },
        funcID: 'E001007',
        PID: 'E00',
        pageConfig: { layout: { class: 'p-0 bg-transparent' } },
      },
      component: () => import('@/views/ecom/hxBiz/hxFtyInvInNotice/detail'),
    },
    {
      path: 'hxFtyInbound',
      name: `${pre}hxFtyInbound`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E001008',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/hxBiz/hxFtyInbound'),
    },
    {
      path: 'hxFtyInbound/:pageType/:hxFtyInboundCode?',
      name: `${pre}hxFtyInbound-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { hxFtyInboundNo = '' } = $route.query || {}
          return `内贸库存入库单 | ${hxFtyInboundNo || 'New'}`
        },
        funcID: 'E001008',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0 m-0' },
        },
      },
      component: () => import('@/views/ecom/hxBiz/hxFtyInbound/detail'),
    },
    {
      path: 'hxSkuInvFtyLocation',
      name: `${pre}hxSkuInvFtyLocation`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E001009',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/hxBiz/hxSkuInvFtyLocation'),
    },
  ])('ecom-hxBiz-'),
}
